var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0099 18.83H13.7299C12.1899 18.83 10.9399 17.58 10.9399 16.04C10.9399 14.67 11.9399 13.52 13.2499 13.29C13.1599 13.15 12.7799 12.41 14.0699 10.84C15.5099 9.08001 15.6299 6.28001 15.2699 4.12001C14.9099 1.96001 12.8699 0.52002 10.7499 0.52002C8.62992 0.52002 6.58992 1.96001 6.22992 4.12001C5.86992 6.28001 5.98992 9.08001 7.42992 10.84C8.86992 12.6 8.22992 13.32 8.22992 13.32C6.50992 15.6 3.74992 14.92 1.94992 16.2C0.149921 17.48 0.589921 20.4 0.589921 20.4H14.3199C14.1199 20.01 13.9999 19.57 13.9999 19.11V18.83H14.0099Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.59 18.83V19.11C19.59 19.58 19.47 20.02 19.27 20.4H20.91C20.91 20.4 21.03 19.59 20.88 18.63C20.56 18.75 20.22 18.83 19.86 18.83H19.58H19.59Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8697 14.7401H18.1097V12.9801C18.1097 12.2601 17.5297 11.6801 16.8097 11.6801C16.0897 11.6801 15.5097 12.2601 15.5097 12.9801V14.7401H13.7497C13.0297 14.7401 12.4497 15.3201 12.4497 16.0401C12.4497 16.7601 13.0297 17.3401 13.7497 17.3401H15.5097V19.1001C15.5097 19.7901 16.0497 20.3501 16.7397 20.3901H16.8897C17.5697 20.3501 18.1197 19.7901 18.1197 19.1001V17.3401H19.8797C20.0797 17.3401 20.2697 17.2901 20.4397 17.2101C20.8797 17.0001 21.1797 16.5601 21.1797 16.0401C21.1797 15.3201 20.5997 14.7401 19.8797 14.7401H19.8697Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.2bd99670cf4136116f865c9305e2e9b0.svg";
export { ForwardRef as ReactComponent };